export default "__VITE_ASSET__DGwNhF0F__"